import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"close\"><defs><style type=\"text/css\"></style></defs><path d=\"M602.477714 488.740571l398.262857-398.262857L910.189714 0 512 398.189714 113.810286 0 23.259429 90.477714l398.262857 398.262857L5.12 905.069714l90.550857 90.550857L512 579.218286l416.329143 416.402285 90.550857-90.550857-416.402286-416.329143z\" p-id=\"6360\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id